export default "__VITE_ASSET__DWsqlyq___"